import { z } from 'zod'

export const InitiateIDResponseSchema = z.object({
  token: z.string(),
  id: z.string(),
})

export const SubmitIDResponseSchema = z.unknown()
